import { render, staticRenderFns } from "./GestionAjustesGenerales.vue?vue&type=template&id=78106f74&lang=es"
import script from "./GestionAjustesGenerales.vue?vue&type=script&lang=js"
export * from "./GestionAjustesGenerales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports